export default "__VITE_ASSET__TOJGGFdu__"